<template>
    <section
        :id="id"
        class=" mb-12">

        <v-btn
            v-show="leftArrow"
            elevation="2"
            absolute
            left
            fab
            @click.stop="scrollLeft(id)">
            <v-icon size="48">mdi-chevron-left</v-icon>
        </v-btn>

        <div class="section-wrapper">
            <h1
                class="white--text"
                v-text="name" />

            <div
                :class="scrollable ? 'scrollable' : ''"
                class="d-flex carousel-wrapper">
                <hobbies-element
                    v-for="(element, index) in elements"
                    :key="`${element.name}-${index}`"
                    :element="element"
                    :width="width"/>
            </div>
        </div>

        <v-btn
            v-show="rightArrow"
            elevation="2"
            absolute
            right
            fab
            @click.stop="scrollRight(id)">
            <v-icon size="48">mdi-chevron-right</v-icon>
        </v-btn>
    </section>
</template>

<script>
import HobbiesElement from '../hobbies/hobbiesElement'

export default {
    name: 'hobbiesElements',
    components: {
        HobbiesElement
    },
    props: {
        elements: {
            type: Array,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        width: {
            type: Number,
            required: true
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.initEvents(this.id)
        })
    }
}
</script>

<style scoped lang="scss">

section {
    position: relative !important;

    .section-wrapper {
        overflow: hidden !important;
        height: max-content !important;

        .carousel-wrapper {
            overflow-y: auto !important;
            margin-bottom: -17px !important;

            &:not(.scrollable) {
                margin-bottom: 0 !important;
            }

            > .v-btn {
                top: calc(50% - 14px) !important;

                &--left {
                    left: -36px !important;
                }

                &--right {
                    right: -36px !important;
                }
            }
        }
    }

    > .v-btn {
        top: calc(50% - 14px) !important;

        &--left {
            left: -36px !important;
        }

        &--right {
            right: -36px !important;
        }
    }
}

@media (max-width: 960px) {
    section .section-wrapper .carousel-wrapper.scrollable {
        margin-bottom: 0 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/hobbies/hobbiesElements.vue